import { createSlice } from "@reduxjs/toolkit";
import type { PayloadAction } from "@reduxjs/toolkit";
import { RegisterDataType } from "store/types/auth";

const initialRegisterState: RegisterDataType = {
  email: "",
  password: "",
};

const registerSlice = createSlice({
  name: "register",
  initialState: initialRegisterState,
  reducers: {
    setRegisterInfo: (state, action: PayloadAction<RegisterDataType>) => (state = action.payload),
  },
});

export const { setRegisterInfo } = registerSlice.actions;
export default registerSlice.reducer;
